/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Course_Totalnodes1Inputs */

const zh_course_totalnodes1 = /** @type {(inputs: Course_Totalnodes1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`节点总数`)
};

const en_course_totalnodes1 = /** @type {(inputs: Course_Totalnodes1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total Nodes`)
};

const es_course_totalnodes1 = /** @type {(inputs: Course_Totalnodes1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nodos totales`)
};

/**
* | output |
* | --- |
* | "Total Nodes" |
*
* @param {Course_Totalnodes1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const course_totalnodes1 = /** @type {((inputs?: Course_Totalnodes1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Course_Totalnodes1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_course_totalnodes1(inputs)
	if (locale === "en") return en_course_totalnodes1(inputs)
	return es_course_totalnodes1(inputs)
});
export { course_totalnodes1 as "course_totalNodes" }